import { render, staticRenderFns } from "./kunden.vue?vue&type=template&id=788915be"
import script from "./kunden.vue?vue&type=script&lang=js"
export * from "./kunden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports